module.exports = __webpack_public_path__ + "static/media/flag02.232e9fd4.svg";